/*** IMPORTS FROM imports-loader ***/
var define = false;

import {gsap} from "gsap";
import $ from 'jquery';
import SplitType from 'split-type'
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {CountUp} from 'countup.js';
import Swiper from 'swiper-bundle.min';

let imagesLoaded = require('imagesloaded');
let safariAgent = navigator.userAgent.indexOf("Safari") > -1;
let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1;
console.log(navigator.userAgent);
gsap.registerPlugin(ScrollTrigger);
let pageLoaded = false
const video = document.querySelector("#bg-video");

// Define the Function targetBlank()
function targetBlank() {
    // remove subdomain of current site's url and setup regex
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");

    var a = document.getElementsByTagName('a'); // then, grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of each link
        if ((!internal.test(href) && !/^javascript/.test(a[i].getAttribute("href"))) || /\.pdf$/.test(a[i].getAttribute("href"))) { // make sure the href doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
        }
    }
}

(function () {
    "use strict";
    console.log('JS loaded');
    targetBlank();


    /* SmoothScroll({
         // Scrolling Core
         animationTime    : 1400, // [ms]
         stepSize         : 100, // [px]

         // Acceleration
         accelerationDelta : 50,  // 50
         accelerationMax   : 3,   // 3

         // Keyboard Settings
         keyboardSupport   : true,  // option
         arrowScroll       : 50,    // [px]

         // Pulse (less tweakable)
         // ratio of "tail" to "acceleration"
         pulseAlgorithm   : true,
         pulseScale       : 4,
         pulseNormalize   : 1,

         // Other
         touchpadSupport   : false, // ignore touchpad by default
         fixedBackground   : true,
         excluded          : ''
     })*/

    if (document.querySelectorAll(".scroll-top").length > 0) {
        document.querySelectorAll('.scroll-top')[0].addEventListener("click", function (event) {
            window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': 0
            });
        });
    }

    if (document.querySelectorAll(".show-all").length > 0) {
        document.querySelectorAll('.show-all')[0].addEventListener("click", function (event) {
            event.preventDefault();
            $('.cards').removeClass('hide');
            $('.show-all-holder').hide();
            let cards = document.querySelectorAll(".card-add");
            [].forEach.call(cards, function (card, index) {

                ScrollTrigger.create({
                    trigger: card,
                    start: "top center",
                    end: "bottom top",
                    onEnter: ({progress, direction, isActive}) => {
                        $(card).addClass('show');
                    }

                });
            });
        });
    }

    if (document.querySelectorAll(".btn-leitung").length > 0) {
        document.querySelectorAll(".btn-leitung")[0].addEventListener("click", function (event) {
            $('.content-leitung').addClass('show');
            $(this).addClass('active');
            $(".btn-team").removeClass('active');
            $('.content-team').removeClass('show');
        });
    }
    if (document.querySelectorAll(".btn-team").length > 0) {
        document.querySelectorAll(".btn-team")[0].addEventListener("click", function (event) {
            $('.content-team').addClass('show');
            $(this).addClass('active');
            $(".btn-leitung").removeClass('active');
            $('.content-leitung').removeClass('show');
        });
    }

    if (document.querySelectorAll("a.btn-kontakt").length > 0) {
        document.querySelectorAll("a.btn-kontakt")[0].addEventListener("click", function (event) {
            var target = document.querySelectorAll('.navbar-collapse')[0];
            var target3 = document.querySelectorAll("button.navbar-toggler")[0];
            target3.className = (target3.className + " open").replace(/ open open/, "");
            target.className = (target.className + " show").replace(/ show show/, "");
            var target2 = document.querySelectorAll('.navbar')[0];
            target2.className = (target2.className + " open").replace(/ open open/, "");
            gsap.to('.navbar-collapse li', {
                translateX: 200,
                opacity: 0,
                duration: 0.1,
                stagger: 0
            });
        });
    }

    if (document.querySelectorAll("button.navbar-toggler").length > 0) {

        gsap.to('.navbar-collapse li', {
            translateX: 200,
            opacity: 0,
            duration: 0
        });
        // Mobile toggler
        document.querySelectorAll("button.navbar-toggler")[0].addEventListener("click", function (event) {
            var target = document.querySelectorAll('.navbar-collapse')[0];
            this.className = (this.className + " open").replace(/ open open/, "");
            target.className = (target.className + " show").replace(/ show show/, "");
            var target2 = document.querySelectorAll('.navbar')[0];
            target2.className = (target2.className + " open").replace(/ open open/, "");

            if (target.classList.contains("show")) {
                setTimeout(function () {
                    gsap.to('.navbar-collapse li', {
                        translateX: 0,
                        opacity: 1,
                        duration: 0.3,
                        stagger: 0.060
                    });
                }, 250);
            } else {
                gsap.to('.navbar-collapse li', {
                    translateX: 200,
                    opacity: 0,
                    duration: 0.1,
                    stagger: 0
                });
            }
        });
    }

    let tlinit = gsap.timeline({
        onComplete: function () {
            console.log('complete');
            $('.loader').hide();
            if (video) {
                video.load();
                video.addEventListener("play", (event) => {
                    console.log('play video')
                    $('.banner .poster-img').addClass('hide');
                });
            }
        }
    });
    tlinit.to('.loader', {
        opacity: 0,
        duration: 0.050
    }, '+=0');

    tlinit.to('.navbar', {
        opacity: 1,
        duration: 0.250
    }, '+=0');
    tlinit.to('main', {
        opacity: 1,
        duration: 0.950,
        onComplete: function () {
            let lines = document.querySelectorAll(".banner .overlay .text");
            [].forEach.call(lines, function (line) {
                console.log('line');
                const t = line
                let lwords = '';
                const lw = new SplitType(t, {types: 'words'})
                lwords = lw.words
                gsap.set('.banner .overlay', {
                    opacity: 1,

                });

                gsap.fromTo(
                    lwords,
                    {
                        x: 50,
                        opacity: 0
                    },
                    {
                        x: 0,
                        opacity: 1,
                        stagger: 0.021,
                        duration: 1,
                        ease: 'power4.out',
                        delay: 0
                    }
                )
            });
        }
    }, '-=0.100');

    tlinit.to('footer', {
        opacity: 1,
        duration: 0.950
    }, '-=0.900');
    //if(document.querySelector('.jquery-background-video'))
        tlinit.pause()

    let tloader = gsap.timeline({
        onComplete: function () {
            console.log('complete loader ani');
            setTimeout(function () {
                tlinit.play()
            }, 1000)

        }
    });
    tloader.addLabel("start", "+=0")
    tloader.to(".loader .cls-1", {
        strokeDasharray: 300,
        strokeDashoffset: 500,
        duration: 1,
        ease: "none",

    });
    tloader.to(".loader .cls-1", {
        strokeDasharray: 200,
        strokeDashoffset: 500,
        duration: 1,
        ease: "none",
        onComplete: function () {
            console.log('complete 1');
            if (!pageLoaded)
                tloader.seek("start");
        }

    });

    tloader.to(".loader .cls-1", {
        strokeDashoffset: 0,
        strokeDasharray: 600,
        duration: 2,
        ease: "none",

    });
    tloader.to(".loader .cls-1", {
        fill: '#FFFFFF',
        strokeWidth: 0,
        duration: 0.3,
        ease: "none"
    }, '-=0.5');
    tloader.to('.loader .cls-2', {
        opacity: 1,
        duration: 0.3,
    }, '-=0.3');





    imagesLoaded(document.querySelector("main"), function (instance) {
        pageLoaded = true
        tlinit.play()
        if ($(document).width() >= 1200 ) {
            // gsap.to(".parallax-bg", {
            //     scrollTrigger: {
            //         scrub: true
            //     },
            //     y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
            //     ease: "none"
            // });

            let headlines = document.querySelectorAll(".headline .line");
            [].forEach.call(headlines, function (headline, index) {
                gsap.to(headline, {
                    scrollTrigger: {
                        trigger: headline,
                        start: "top bottom", // When the top of the trigger reaches the top of the viewport
                        end: "bottom top", // When the bottom of the trigger reaches the top of the scroller
                        scrub: 0.5
                    },
                    x: (i, target) => (-ScrollTrigger.maxScroll(window) * target.dataset.speed),
                    ease: "easeOut"
                });
            })

        }


        //image swiper
        let swiperi = new Swiper(".image-swiper", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            speed: 300,
            effect: 'fade',

            crossFade: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + '</span>';
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });


        //count up
        function initCountUp(target) {
            //console.log(target);
            let countups = target.querySelectorAll(" .mycount");
            [].forEach.call(countups, function (count, index) {
                if (!$(count).hasClass('done')) {


                    if (safariAgent && !chromeAgent) {
                        //var numAnim = new CountUp(count, $(count).data("value"), {duration: 1, separator: ' '});
                        //numAnim.start();
                        $(count).addClass('done');
                        $(count).html($(count).data("value"));

                    } else {
                        var numAnim = new CountUp(count, $(count).data("value"), {duration: 4, separator: ' '});
                        numAnim.start();
                        $(count).addClass('done');
                    }
                }
            });
            let countups2 = target.querySelectorAll(" .mycount2");
            [].forEach.call(countups2, function (count, index) {
                if (!$(count).hasClass('done')) {


                    if (safariAgent && !chromeAgent) {
                        //var numAnim = new CountUp(count, $(count).data("value"), {duration: 1, separator: ' '});
                        //numAnim.start();
                        $(count).addClass('done');
                        $(count).html($(count).data("value"));

                    } else {
                        var numAnim = new CountUp(count, $(count).data("value"), {duration: 4, separator: ' ', decimalPlaces: 1, decimal: ','});
                        numAnim.start();
                        $(count).addClass('done');
                    }
                }
            });
        }

        let imgsreveals = document.querySelectorAll(".img-reveal");
        [].forEach.call(imgsreveals, function (img, index) {
            ScrollTrigger.create({
                trigger: img,
                start: "top bottom",
                end: "bottom top",
                onEnter: ({progress, direction, isActive}) => {
                    img.classList.add('reveal-ready')
                    img.classList.add('reveal')
                }

            });
        });


        let showmodul = document.querySelectorAll(".show-modul");
        [].forEach.call(showmodul, function (modul, index) {
            console.log(modul);
            $(modul).on('mouseenter', function () {
                console.log('mouseenter ' + $(this).data('svg'));
                $('.modul-svgs .e' + $(this).data('svg')).addClass('show');
            });
            $(modul).on('mouseleave', function () {
                console.log('mouseleave');
                $('.modul-svgs .geschoss').removeClass('show');
            });
        });


        let stats = document.querySelectorAll(".countup");
        [].forEach.call(stats, function (stat, index) {
            //console.log(stat);
            ScrollTrigger.create({
                trigger: stat,
                start: "top bottom",
                end: "bottom top",
                onEnter: ({progress, direction, isActive}) => {
                    initCountUp(stat);
                }

            });
        });


        let $start = "top bottom";
        if (window.innerWidth < 1000) {
            $start = "top bottom";
        }


        let svgs = document.querySelectorAll(".svg-seq");
        [].forEach.call(svgs, function (svg, index) {

            ScrollTrigger.create({
                trigger: svg,
                start: $start,
                end: "bottom top",
                onEnter: ({progress, direction, isActive}) => {
                    $(svg).addClass('show');
                    gsap.to('#' + $(svg).attr('id') + ' svg .phase', {
                        opacity: 1,
                        duration: 0.4,
                        stagger: 0.2
                    });
                }

            });
        });

        let layers = document.querySelectorAll(".layers");
        [].forEach.call(layers, function (layer, index) {

            ScrollTrigger.create({
                trigger: layer,
                start: $start,
                end: "bottom top",
                onEnter: ({progress, direction, isActive}) => {
                    $(layer).addClass('show');
                    gsap.to('#' + $(layer).attr('id') + ' .layer', {
                        opacity: 1,
                        duration: 0.8,
                        delay: 0.5,
                        stagger: 0.6
                    });
                }

            });
        });
        let zooms = document.querySelectorAll(".zoom-image");
        [].forEach.call(zooms, function (zoom, index) {

            ScrollTrigger.create({
                trigger: zoom,
                start: $start,
                end: "bottom top",
                onEnter: ({progress, direction, isActive}) => {
                    $(zoom).addClass('show');
                }

            });
        });

        let gallImgs = document.querySelectorAll(".gall-image");
        [].forEach.call(gallImgs, function (img, index) {

            ScrollTrigger.create({
                trigger: img,
                start: $start,
                end: "bottom top",
                onEnter: ({progress, direction, isActive}) => {
                    $(img).addClass('show');
                }

            });
        });


        let cards3 = document.querySelectorAll(".card-text");
        [].forEach.call(cards3, function (card, index) {

            ScrollTrigger.create({
                trigger: card,
                start: $start,
                end: "bottom top",
                onEnter: ({progress, direction, isActive}) => {
                    $(card).addClass('show');
                }

            });
        });


        //form

        $(".rex-yform .form-control")
            .on("focusout", function () {
                console.log('out')
                $(this).parent().removeClass('focus')

            })
            .on("focus", function () {
                console.log('in')
                $(this).parent().addClass('focus')
            });

    });


})();

window.addEventListener("scroll", function () {
    var nav = document.getElementById("mainNav");
    if (window.scrollY > 100) {
        nav.classList.add("shrink");
    } else {
        nav.classList.remove("shrink");
    }
});


